__turbopack_context__.v({
  "chartTitle": "ChartHeader-module-scss-module__kyAxTa__chartTitle",
  "issueChartButtons": "ChartHeader-module-scss-module__kyAxTa__issueChartButtons",
  "leftBorder": "ChartHeader-module-scss-module__kyAxTa__leftBorder",
  "question": "ChartHeader-module-scss-module__kyAxTa__question",
  "questionFill": "ChartHeader-module-scss-module__kyAxTa__questionFill",
  "rightBorder": "ChartHeader-module-scss-module__kyAxTa__rightBorder",
});
